import loadable from '@loadable/component'

export const Rating = loadable(() => import('./Rating'))
export const Ratings = loadable(() => import('./Ratings'))
export type { RatingProps, RatingRenderLinkProps } from './Rating'
export type { RatingsProps } from './Ratings'
